import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'NavBanner',
})(({ brandColors, breakpoints, type, typography, spacing }) => ({
  topBannerOuter: {
    alignSelf: 'stretch',
    color: brandColors.offWhite,
    '& a': {
      textDecoration: 'none',
    },
  },
  topBanner: {
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `${typography.pxToRem(4)} 0`,
    [breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  topBannerLight: {
    background: `linear-gradient(270deg, rgba(116, 107, 26, 0.12) 0%, rgba(116, 107, 26, 0.06) 100.08%)`,
  },
  topBannerDark: {
    background: `linear-gradient(270deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.06) 100.08%)`,
  },
  topBannerSolidDark: {
    background: brandColors.tintsHeroBlue10,
  },
  onLightText: {
    color: brandColors.mediumBlue,
    '&:hover, &:focus': {
      color: brandColors.primaryMain,
    },
  },
  onDarkText: {
    color: brandColors.white,
    '&:hover, &:focus': {
      color: brandColors.offWhite,
    },
  },
  locationContainer: {
    display: 'none',
    [breakpoints.up('md')]: {
      display: 'block',
    },
  },
  bannerItem: {
    flex: 1,
  },
  contact: {
    ...type['14_medium'],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: spacing(1),
    [breakpoints.up('md')]: {
      justifyContent: 'flex-end',
    },
  },
  promo: {
    ...type['14_medium'],
    flex: 1,
    display: 'none',
    textAlign: 'center',
    [breakpoints.up('md')]: {
      display: 'block',
      width: 'fit-content',
      margin: '0 auto',
    },
    '&:hover, &:focus': {
      textDecoration: 'underline',
    },
  },
  phone: {
    display: 'flex',
    minHeight: typography.pxToRem(48),
    padding: `${typography.pxToRem(12)} ${typography.pxToRem(8)}`,
    justifyContent: 'center',
    alignItems: 'center',
    gap: typography.pxToRem(6),
    '&:hover, &:focus': {
      textDecoration: 'underline',
    },
  },
  login: {
    display: 'none',
    padding: `${typography.pxToRem(12)} ${typography.pxToRem(8)}`,
    '&:hover, &:focus': {
      textDecoration: 'underline',
    },
    [breakpoints.up('md')]: {
      display: 'unset',
    },
  },
  centerOnMobile: {
    margin: '0 auto',
    [breakpoints.up('md')]: { margin: 'unset' },
  },
}));

export default useStyles;
